import { type MCPServerInfo } from '../../types';

const GreenhouseServer: MCPServerInfo = {
  serverId: 'GREENHOUSE',
  name: 'Greenhouse',
  slug: 'greenhouse',
  description: 'Greenhouse MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'https://github.com/natomalabs/greenhouse-mcp',
    commitSha: '01567d60',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['greenhouseApiKey'],
    properties: {
      greenhouseApiKey: {
        type: 'string',
        description: 'greenhouse API Key',
        sensitive: true
      }
    }
  },
  deprecated: true
};

export default GreenhouseServer;
